/**
 * Shape and density tokens — the EIS Design System 2025 geometry (T-31, amending T-8).
 *
 * Four radii carry the whole look: 4 for controls (buttons, inputs), 5 for containers (cards,
 * dialogs, menus), 10 for badges and the logo tile, 22 for pills (the tab strip). The tonal
 * status chip sits between them at 6, as design v2 draws it.
 *
 * Density is the console's, not the design's: this is a back-office tool where an operator reads
 * twenty rows at a glance (CLAUDE.md rule 4), so the `size="small"` defaults survive the restyle;
 * rows grow to the design's 44px and the header keeps prompt 22's 52px.
 */
export const radius = {
  none: 0,
  /** Controls: buttons, inputs, icon buttons, toggles. */
  control: 4,
  /** Containers: cards, dialogs, menus, popovers, alerts, the grid frame. */
  surface: 5,
  /** The v2 tonal status chip. */
  chip: 6,
  /** Metadata badges, the logo tile, entity icon tiles. */
  badge: 10,
  /** A selected pill tab inside the strip. */
  tab: 18,
  /** Pills: the tab strip, the profile chip. */
  pill: 22,
} as const;

export const spacingUnit = 8;

export const density = {
  /** Data Grid row height — the design's 44px table row. */
  gridRowHeight: 44,
  gridHeaderHeight: 52,
  toolbarHeight: 56,
  /** The expanded navigation rail. */
  navWidth: 248,
  /** Icon-only rail: one 40px button plus its gutters, so icons stay optically centred. */
  navWidthCollapsed: 76,
} as const;

export const typographyTokens = {
  fontFamily: '"Open Sans", "Helvetica Neue", -apple-system, "Segoe UI", sans-serif',
  monoFamily: '"JetBrains Mono", "SFMono-Regular", Menlo, Consolas, monospace',
} as const;
